import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/svg/arrowLeft.svg'
import _imports_1 from '@/assets/icons/svg/arrowRight.svg'
import _imports_2 from '@/assets/icons/svg/close.svg'


const _hoisted_1 = { class: "w-full h-full bg-gray-background relative" }
const _hoisted_2 = { class: "absolute z-10" }
const _hoisted_3 = { class: "m-4 flex flex-row" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row flex-grow justify-center mx-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_0,
  alt: "previous"
}, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_1,
  alt: "next"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 h-6",
  src: _imports_2,
  alt: "close"
}, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "relative w-screen h-screen bg-white" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlButton = _resolveComponent("SlButton")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_carousel_trigger = _resolveComponent("carousel-trigger")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.disableDelays)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.currentPageIndex > 0)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 0,
                    id: "picturebook-prev",
                    class: "mr-2",
                    "background-class": 'bg-white',
                    "extra-classes": "w-12",
                    "custom-width": '3rem',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prev()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.currentPageIndex < _ctx.question.pages.length - 1)
                ? (_openBlock(), _createBlock(_component_SlButton, {
                    key: 1,
                    id: "picturebook-next",
                    "background-class": 'bg-white',
                    "extra-classes": "w-12",
                    "custom-width": '3rem',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_SlButton, {
          id: "picturebook-finish",
          "extra-classes": "w-12",
          "background-class": _ctx.allPagesDone ? 'bg-green-highlight' : 'bg-white',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.finish()))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["background-class"])
      ])
    ]),
    _createVNode(_component_Carousel, {
      class: "h-full",
      onMousedown: _ctx.activateMouseCheck,
      onTouchstart: _ctx.activateMouseCheck,
      onMousemove: _ctx.checkMouse,
      onTouchmove: _ctx.checkMouse,
      onMouseup: _ctx.deactivateMouseCheck,
      onTouchend: _ctx.deactivateMouseCheck
    }, {
      addons: _withCtx(() => [
        _createVNode(_component_carousel_trigger, {
          ref: "carouselTriggerRef",
          onNewPage: _ctx.newPage
        }, null, 8 /* PROPS */, ["onNewPage"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.pages, (page, index) => {
          return (_openBlock(), _createBlock(_component_Slide, {
            key: `page-${index}`,
            index: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    class: "w-full pointer-events-none",
                    src: page.mainBackground,
                    alt: "background image"
                  }, null, 8 /* PROPS */, _hoisted_10),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.overlays, (overlay) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(overlay.__typename), {
                      key: overlay.id,
                      overlay: overlay,
                      "show-pulse": _ctx.showPulse,
                      page: _ctx.currentPageIndex,
                      enabled: index === _ctx.currentPageIndex && _ctx.currentOverlay && overlay.id === _ctx.currentOverlay.id,
                      onComplete: _ctx.completeOverlay
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["overlay", "show-pulse", "page", "enabled", "onComplete"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (page.mainForeground)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "w-full absolute top-0 left-0 pointer-events-none",
                        src: page.mainForeground,
                        alt: "foreground image"
                      }, null, 8 /* PROPS */, _hoisted_11))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", {
                  class: "w-full flex flex-col place-items-center justify-center xl:absolute xl:bottom-2 xl:left-2 xl:bg-sl-transl",
                  style: {"height":"18%"},
                  innerHTML: page.text
                }, null, 8 /* PROPS */, _hoisted_12),
                (_ctx.allPagesDone)
                  ? (_openBlock(), _createBlock(_component_SlButton, {
                      key: 0,
                      id: "picturebook-finish2",
                      class: "absolute bottom-2 right-2",
                      "extra-classes": "w-20",
                      "background-class": 'bg-green-highlight',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.finish()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('done')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onMousedown", "onTouchstart", "onMousemove", "onTouchmove", "onMouseup", "onTouchend"])
  ]))
}